import { render, staticRenderFns } from "./product-related-types-listing.vue?vue&type=template&id=9e0a79a4&"
import script from "./product-related-types-listing.vue?vue&type=script&lang=js&"
export * from "./product-related-types-listing.vue?vue&type=script&lang=js&"
import style0 from "./product-related-types-listing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports